import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  ScreenAccessLogService,
  ScreenCode,
} from 'src/app/shared/services/screen-access-log/screen-access-log.service';

@Component({
  selector: 'app-bloco-empresas',
  templateUrl: './bloco-empresas.component.html',
  styleUrls: ['./bloco-empresas.component.scss'],
  standalone: true,
})
export class BlocoEmpresasComponent {
  @Output() closeEmpresas = new EventEmitter<void>();

  private readonly screenAccessLog = inject(ScreenAccessLogService);

  private readonly telasPorTipo: Record<string, ScreenCode> = {
    salvas: 'EMPRESA_BUSCAS_SALVAS',
    novo: 'BUSCA_EMPRESAS',
  };

  constructor(private router: Router) {}

  navigateTo(tipo: 'salvas' | 'novo'): void {
    const tela = this.telasPorTipo[tipo];
    if (tela) {
      this.screenAccessLog.registrar(tela);
    }

    const rota = tipo === 'novo' ? '/empresas' : `/empresas/${tipo}`;
    this.router.navigate([rota]);
    this.closeEmpresas.emit();
  }
}